import { css } from "@emotion/css";
import { Callout } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import DeleteDialogLayout from "~/components/Dialog/DeleteDialogLayout";
interface StopShareTemplateDialogProps {
    onSave: (sharedSpaces: SharedSpaces) => Promise<void>;
    onClose: () => void;
}
export interface SharedSpaces {
    shareToAll: boolean;
    individualSpacesSharedTo: string[];
    constraintExceptionSpaceIds: string[];
}
export function StopShareTemplateDialog({ onSave, onClose }: StopShareTemplateDialogProps) {
    return (<div className={styles.container}>
            <DeleteDialogLayout title={"Stop sharing this template?"} onDeleteClick={async () => {
            await onSave({ shareToAll: false, individualSpacesSharedTo: [], constraintExceptionSpaceIds: [] });
            return true;
        }} deleteButtonLabel={"Stop sharing"} deleteButtonBusyLabel={"Updating..."} onClose={onClose} renderContent={() => (<div className={styles.content}>
                        <Callout type={"warning"} title={"This could affect deployment processes in spaces using this template."}></Callout>
                        <span>Existing releases can still be run using this template, but it can't be included in new releases or deployment processes.</span>
                    </div>)}/>
        </div>);
}
const styles = {
    content: css({
        display: "flex",
        flexDirection: "column",
        gap: space[8],
    }),
    container: css({
        margin: space[24],
    }),
};
